module.exports = __webpack_public_path__ + "static/media/destination_pin.5c20d39e.png";